/* eslint-disable react/display-name */
import { Button, IconButton, Tooltip, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";

import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TaxCrud from "./TaxCrud.jsx";

export default function TaxList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  function addTax() {
    biRef.child.showTaxCrudWindow(null);
  }

  function onEditClicked(row) {
    biRef.child.showTaxCrudWindow(row.tableData[row.rowIndex].id);
  }

  async function loadData() {
    //loadByRest();
    loaadByDB();
  }
  async function loadByRest() {}
  async function loaadByDB() {
    db.tax.toArray(function (data) {
      setData(data);
    });
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    download: false,
    search: false,
    filter: false,
    pagination: false,
    viewColumns: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    print: false,
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton size="small" color="primary" onClick={taxListRefresh}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={translate("Add Tax")}>
            <IconButton size="small" color="secondary" onClick={addTax}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const columns = [
    {
      name: "name",
      label: translate("Name"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "right",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onEditClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={{
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            }}
          >
            Edit
          </Button>
        ),
      },
    },
  ];

  function taxListRefresh() {
    loadData();
  }

  var biRef = {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={translate("Tax List")}
            data={data}
            columns={columns}
            options={options}
          />
        </div>
      </Grid>
      <TaxCrud
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        onRefresh={taxListRefresh}
      ></TaxCrud>
    </Grid>
  );
}
